import { Box, Stack, Typography } from '@mui/material';
import { PropsWithChildren, ReactNode } from 'react';

type CleaningPageProps = {
  title: string;
  toolbar?: ReactNode;
};

const CleaningPage = ({ title, toolbar, children }: PropsWithChildren<CleaningPageProps>) => (
  <Stack sx={{ flex: 1, minHeight: 0, bgcolor: 'primary.main' }}>
    <Stack
      spacing={3}
      sx={{ flex: 'none', paddingTop: 'calc(env(safe-area-inset-top) + 14px)', paddingBottom: '14px', paddingX: 4 }}
    >
      <Typography
        component="h1"
        sx={{ fontSize: 28, fontWeight: 800, letterSpacing: '-0.02em', lineHeight: 1.2, color: 'common.white' }}
      >
        {title}
      </Typography>
      {toolbar}
    </Stack>
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        overflowY: 'auto',
        bgcolor: 'common.white',
        borderRadius: '20px 20px 0 0',
      }}
    >
      {children}
    </Box>
  </Stack>
);

export default CleaningPage;
